export default class LockScroll{
  constructor(){
    this.body = document.getElementsByTagName('body')[0];
    this.is_lock = false;
  }

  lock(scrollTop = null){
    this.is_lock = true;
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.body.style.position = "fixed";
    this.body.style.overflowY = "scroll";

    if (scrollTop !== null){
      console.log(scrollTop);
      this.body.style.top = -scrollTop+'px';
    }
  }

  unlock(scrollTop = null){
    if (!this.is_lock) return false;
    this.is_lock = false;
    this.body.style.position = "static";
    this.body.style.overflowY = "auto";
    if (scrollTop ==  null){
      scrollTop = this.scrollTop;
    }
    document.documentElement.scrollTop = document.body.scrollTop = scrollTop;

  }

}
